<script lang="ts">
    import { fade } from "svelte/transition";
</script>

<div
    class="gw-modal-backdrop"
    on:click
    on:keypress
    transition:fade={{ duration: 200 }}
/>

<style>
    .gw-modal-backdrop {
        display: block;
        position: fixed;
        right: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.75;
        background-color: var(--gw-modal-backdrop-bg);
    }
</style>
